import styled from 'styled-components'

export const TextContainer = styled.div`
    width: 100%;
    padding: 0 1rem 2rem 1rem;
`